const initialState = {
  site: {},
  siteSummary: {},
  sites: [],
  fetching: false,
  fetched: false,
  errors: null,
  saved: false,
  saving: false,
  duplicatePending: false,
  duplicateFulfilled: false,
  duplicateErrors: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SITES_FETCH_PENDING":
    case "CHILD_COMPANY_SITES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: null,
      }
    case "SITES_FETCH_REJECTED":
    case "CHILD_COMPANY_SITES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "SITES_FETCH_FULFILLED":
    case "CHILD_COMPANY_SITES_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        sites: action.payload.data,
        errors: null,
      }
    case "SITE_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        site: null
      }
    case "SITE_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        site: action.payload.data
      }
    case "PARENT_COMPANY_SITE_DUPLICATE_PENDING":
      return {
        ...state,
        duplicatePending: true,
        duplicateFulfilled: false,
        duplicateErrors: null,
      }
    case "PARENT_COMPANY_SITE_DUPLICATE_REJECTED":
      return {
        ...state,
        duplicatePending: false,
        duplicateFulfilled: false,
        duplicateErrors: action.payload.data['errors'],
      }
    case "PARENT_COMPANY_SITE_DUPLICATE_FULFILLED":
      return {
        ...state,
        duplicatePending: false,
        duplicateFulfilled: true,
        duplicateErrors: null,
      }
    case  'USER_SIGN_OUT_PENDING':
      return {
        ...initialState
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState
      }
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/sitesReducer.js